import { useContext, useState } from "react";
import SettingLayout from "../SettingLayout";
import "../../../../styles/dashboard/setting/SettingLayout.css";
import {
  RazorButton,
  RazorToggleSlide,
} from "../../../../components/razor-reuse";
import ChangePasswordModal from "./modals/ChangePasswordModal";
import ActionContext from "../../../../context/ActionContext";
import EnableMFAPassword from "./modals/EnableMFAPassword";
import SetupMFAModal from "./modals/SetupMFAModal";
import VerifyMFAOtp from "./modals/VerifyMFAOtp";
import DisableMFAPrompt from "./modals/DisableMFAPrompt";
import DisableMFAOtp from "./modals/DisableMFAOtp";
import { useSelector } from "react-redux";
import RootState from "../../../../redux/type";

type modalProps = {
  change_password: boolean;
  mfa_password: boolean;
  mfa_setup: boolean;
  mfa_otp: boolean;
  mfa_disable: boolean;
  otp_disable: boolean;
};

const AccountIndex = () => {
  //   const [refreshTable, setRefreshTable] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<modalProps>({
    change_password: false,
    mfa_setup: false,
    mfa_password: false,
    mfa_otp: false,
    mfa_disable: false,
    otp_disable: false,
  });
  // const [enableFA, setEnableFA] = useState(false); //State for managing the 2FA

  const { user, loading_user } = useSelector((state: RootState) => state.auth); // Get logged in user details
  // console.log({ user });

  const actionCtx = useContext(ActionContext);
  const accountList = [
    {
      title: "Password Manager",
      text: "Change the password for this account",
      btnLabel: "Change Password",
      onBtnClick: () => {
        setShowModal((prev) => {
          return { ...prev, change_password: true };
        });
      },
    },
    {
      title: "End Sessions",
      text: "Logout all sessions except on this current broswer",
      btnLabel: "End Sessions",
      onBtnClick: () => {
        actionCtx?.setLogout && actionCtx?.setLogout(true);
      },
    },
    {
      title: "Two Factor Authentication",
      text: "This would require an authentication code  when you log in with an email and password",
      onBtnClick: () => {
        if (user?.is_2fa_enabled === 1) {
          setShowModal((prev) => {
            return { ...prev, mfa_disable: true };
          });
        } else {
          setShowModal((prev) => {
            return { ...prev, mfa_setup: true };
          });
        }
      },
      switchState: user?.is_2fa_enabled === 1,
    },
    // {
    //   title: "Theme",
    //   text: "Set your account display theming that suit your perefernce",
    //   selectOption: [
    //     { label: "Light Theme", value: "light" },
    //     { label: "Dark Theme", value: "dark" },
    //   ],
    //   onSelect: (param: any) => {
    //     console.log(param);

    //   },
    // },
  ];

  return (
    <>
      <SettingLayout hideBtn title="Account" pageLoading={loading_user}>
        <div className="account-settings-layout-index-wrap-box">
          {accountList?.map((chi, idx) => {
            return (
              <div key={idx} className="card-item">
                {/* title text box start */}
                <div className="title-text-box">
                  <p className="title">{chi?.title}</p>
                  <p className="text">{chi?.text}</p>
                </div>
                {/* title text box end */}
                {chi?.btnLabel && (
                  <div className="btn-action-box">
                    <RazorButton
                      color="black-light"
                      className="btn"
                      label={chi?.btnLabel}
                      onClick={() => {
                        chi?.onBtnClick && chi?.onBtnClick();
                      }}
                    />
                  </div>
                )}
                {!chi?.btnLabel && (
                  <abbr title="Toggle 2FA">
                    <RazorToggleSlide
                      checked={chi?.switchState}
                      onChange={() => {
                        chi?.onBtnClick && chi?.onBtnClick();
                      }}
                      color={`black-light`}
                    />
                  </abbr>
                )}
                {/* {Number(chi?.selectOption?.length) > 0 && (
                  <>
                    <RazorInputField
                    className="select-class"
                      color="black-light"
                      type="select"
                      selectOption={chi?.selectOption}
                      selectStyles={reactSelectStyleTable}
                      onChange={(e: any) => {
                        chi?.onSelect && chi?.onSelect(e);
                      }}
                    />
                  </>
                )} */}
              </div>
            );
          })}
        </div>
      </SettingLayout>
      {/* modal start here  */}
      <ChangePasswordModal
        visible={showModal?.change_password}
        onClose={() => {
          setShowModal((prev) => {
            return { ...prev, change_password: false };
          });
        }}
      />

      <EnableMFAPassword
        visible={showModal?.mfa_password}
        onClose={() => {
          setShowModal((prev) => {
            return { ...prev, mfa_password: false };
          });
        }}
        onSuccess={() => {
          setShowModal((prev) => {
            return { ...prev, mfa_setup: true };
          });
        }}
      />

      <SetupMFAModal
        visible={showModal?.mfa_setup}
        onClose={() => {
          setShowModal((prev) => {
            return { ...prev, mfa_setup: false };
          });
        }}
        onSuccess={() => {
          setShowModal((prev) => {
            return { ...prev, mfa_setup: false, mfa_otp: true };
          });
        }}
      />

      <VerifyMFAOtp
        visible={showModal?.mfa_otp}
        onClose={() => {
          //   setStep(1);
          setShowModal((prev) => {
            return { ...prev, mfa_otp: false };
          });
        }}
      />

      <DisableMFAPrompt
        visible={showModal?.mfa_disable}
        onClose={() => {
          setShowModal((prev) => {
            return { ...prev, mfa_disable: false };
          });
        }}
        onSuccess={() => {
          setShowModal((prev) => {
            return { ...prev, otp_disable: true };
          });
        }}
      />

      <DisableMFAOtp
        visible={showModal?.otp_disable}
        onClose={() => {
          setShowModal((prev) => {
            return { ...prev, otp_disable: false };
          });
        }}
      />

      {/* modal start end */}
    </>
  );
};

export default AccountIndex;
